// アコーディオン
$(".question").on("click", function() {
    $(this).next().slideToggle("fast");
    $("html,body").animate();
    if ($(this).hasClass("active")) { // クリックされた要素がclickedクラスだったら
        $(this).removeClass("active");
    } else {
        $(this).addClass("active");
    }
});
// アコーディオン
$(".faq-list_Title").on("click", function() {
    $(this).next().slideToggle("fast");
    $("html,body").animate();
    if ($(this).hasClass("active")) { // クリックされた要素がclickedクラスだったら
        $(this).removeClass("active");
    } else {
        $(this).addClass("active");
    }
});

// アコーディオン
$(".js-trigger__globalSearch").on("click", function() {
    $(this).next().slideToggle("fast");
    $("html,body").animate();
    if ($(this).hasClass("active")) { // クリックされた要素がclickedクラスだったら
        $(this).removeClass("active");
    } else {
        $(this).addClass("active");
    }
});
// アコーディオン
$(".js-rpt_Trigger").on("click", function() {
    $(this).next().slideToggle("fast");
    $("html,body").animate();
    if ($(this).hasClass("active")) { // クリックされた要素がclickedクラスだったら
        $(this).removeClass("active");
    } else {
        $(this).addClass("active");
    }
});
// アコーディオン
$(".st-themeList__innr-themeList").on("click", function() {
    $(this).next("st-themeList__innr-topicList").slideToggle("fast");
    $("html,body").animate();
    if ($(this).hasClass("active")) { // クリックされた要素がclickedクラスだったら
        $(this).removeClass("active");
    } else {
        $(this).addClass("active");
    }
});
// アコーディオン
$(".c-noteList__body-trigger").on("click", function() {
    $(this).before().next().slideToggle("fast");
    $("html,body").animate();
    if ($(this).hasClass("active")) { // クリックされた要素がclickedクラスだったら
        $(this).removeClass("active");
        $(this).$(".c-noteList__body-read").text("続きを読む");
    } else {
        $(this).addClass("active");
        $(this).$(".c-noteList__body-read").text("閉じる");
    }
});


    $(".st-themeList__innr-body").on("click", function() {
        $(this).next().slideToggle("fast");
        $("html,body").animate();
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
        } else {
            $(this).addClass("active");
        }
    });
